import {
  CommentConfigurator,
  SingleSelectionConfigurator,
  MultipleSelectionConfigurator,
} from '@bingads-webui-campaign-react/survey-factory-tools';

export const EscWebuiUserPauseCampaignSurveyConfig = (options) => {
  const {
    i18n,
  } = options;

  return {
    featureArea: 'EscWebuiUserPauseCampaignSurvey',
    style: {
      root: {
        minWidth: 600,
        '@media (max-width: 600px)': {
          minHeight: 320,
          minWidth: 340,
        },
      },
    },
    others: {
      isGlobalModalStyleEnabled: true,
      isThankYouPageEnabled: false,
      isUserInitiatedSurvey: true,
      combineTextInputToComment: true,
      isInPageMiddle: true,
    },
    questions: [
      {
        isRequired: false,
        Type: SingleSelectionConfigurator,
        key: 'q1',
        page: 0,
        position: 0,
        getTitle: () => i18n.getString(_TL_('Hi there! We have two questions for you. Please tell us the main reason you\'re pausing or deleting this ad campaign.')),
        isVisible: () => true,
        options: [
          {
            key: 'q1o1',
            text: i18n.getString(_TL_('I was just trying it out')),
          },
          {
            key: 'q1o2',
            text: i18n.getString(_TL_('I ran out of budget')),
          },
          {
            key: 'q1o3',
            text: i18n.getString(_TL_('I\'m moving my advertising budget elsewhere')),
          },
          {
            key: 'q1o4',
            text: i18n.getString(_TL_('My ad campaign is too expensive')),
          },
          {
            key: 'q1o5',
            text: i18n.getString(_TL_('I\'m not getting enough return on investment (ROI)')),
          },
          {
            key: 'q1o6',
            text: i18n.getString(_TL_('When I search for my ads in Google or Bing, they don\'t show')),
          },
          {
            key: 'q1o7',
            text: i18n.getString(_TL_('I want more control over my ad campaigns')),
          },
          {
            key: 'q1o8',
            text: i18n.getString(_TL_('It\'s difficult to use the product')),
          },
          {
            key: 'q1o9',
            hasInput: true,
            text: i18n.getString(_TL_('Other')),
            placeholder: i18n.getString(_TL_('Other')),
          },
        ],
      },
      {
        isRequired: false,
        Type: SingleSelectionConfigurator,
        key: 'q2',
        page: 1,
        position: 2,
        getTitle: () => i18n.getString(_TL_('Will you advertise with us again in the future?')),
        options: [
          {
            key: 'q2o1',
            text: i18n.getString(_TL_('Yes')),
          },
          {
            key: 'q2o2',
            text: i18n.getString(_TL_('No')),
          },
        ],
        isVisible: answers => (answers.q1.selectedOption === 'q1o1') || (answers.q1.selectedOption === 'q1o2'),
      },
      {
        isRequired: false,
        Type: MultipleSelectionConfigurator,
        key: 'q3',
        page: 1,
        position: 2,
        getTitle: () => i18n.getString(_TL_('What will you use for advertising? Choose all that apply:')),
        options: [
          {
            key: 'q3o1',
            text: i18n.getString(_TL_('Ad advertising agency')),
          },
          {
            key: 'q3o2',
            text: i18n.getString(_TL_('Advertising directly on Google Ads, Microsoft Advertising, or Meta Ads')),
          },
          {
            key: 'q3o3',
            text: i18n.getString(_TL_('Other social media ads like Twitter, LinkedIn, Pinterest')),
          },
          {
            key: 'q3o4',
            text: i18n.getString(_TL_('Review sites like Yelp or Angie\'s List')),
          },
          {
            key: 'q3o5',
            text: i18n.getString(_TL_('TV or radio ads')),
          },
          {
            key: 'q3o6',
            text: i18n.getString(_TL_('Offline ads in publications like magazines or newspapers')),
          },
          {
            key: 'q3o7',
            hasInput: true,
            text: i18n.getString(_TL_('Other')),
            placeholder: i18n.getString(_TL_('Other')),
          },
        ],
        isVisible: answers => answers.q1.selectedOption === 'q1o3',
      },
      {
        isRequired: false,
        Type: MultipleSelectionConfigurator,
        key: 'q4',
        page: 1,
        position: 2,
        getTitle: () => i18n.getString(_TL_('What makes your campaign seem too expensive? (Select all that apply.)')),
        options: [
          {
            key: 'q4o1',
            text: i18n.getString(_TL_('I am not getting quality leads.')),
          },
          {
            key: 'q4o2',
            text: i18n.getString(_TL_('I get calls and clicks outside my business hours.')),
          },
          {
            key: 'q4o3',
            text: i18n.getString(_TL_('I\'m not sure if my ads were running.')),
          },
          {
            key: 'q4o4',
            text: i18n.getString(_TL_('The cost-per-click is too high.')),
          },
          {
            key: 'q4o5',
            hasInput: true,
            text: i18n.getString(_TL_('Other')),
            placeholder: i18n.getString(_TL_('Other')),
          },
        ],
        isVisible: answers => answers.q1.selectedOption === 'q1o4',
      },
      {
        isRequired: false,
        Type: MultipleSelectionConfigurator,
        key: 'q5',
        page: 1,
        position: 2,
        getTitle: () => i18n.getString(_TL_('What were you hoping to get more of? Choose all that apply:')),
        options: [
          {
            key: 'q5o1',
            text: i18n.getString(_TL_('Clicks')),
          },
          {
            key: 'q5o2',
            text: i18n.getString(_TL_('Calls')),
          },
          {
            key: 'q5o3',
            text: i18n.getString(_TL_('Visits to your physical business location')),
          },
          {
            key: 'q5o4',
            text: i18n.getString(_TL_('Sales')),
          },
          {
            key: 'q5o5',
            hasInput: true,
            text: i18n.getString(_TL_('Other')),
            placeholder: i18n.getString(_TL_('Other')),
          },
        ],
        isVisible: answers => answers.q1.selectedOption === 'q1o5',
      },
      {
        isRequired: false,
        Type: MultipleSelectionConfigurator,
        key: 'q6',
        page: 1,
        position: 2,
        getTitle: () => i18n.getString(_TL_('Please tell us more. Choose all that apply.')),
        options: [
          {
            key: 'q6o1',
            text: i18n.getString(_TL_('I only find automated ads when I search for my ads on Google or Bing.')),
          },
          {
            key: 'q6o2',
            text: i18n.getString(_TL_('I don\'t find any ads for my business when I search for it on Google or Bing.')),
          },
          {
            key: 'q6o3',
            hasInput: true,
            text: i18n.getString(_TL_('Other')),
            placeholder: i18n.getString(_TL_('Other')),
          },
        ],
        isVisible: answers => answers.q1.selectedOption === 'q1o6',
      },
      {
        isRequired: false,
        Type: MultipleSelectionConfigurator,
        key: 'q7',
        page: 1,
        position: 2,
        getTitle: () => i18n.getString(_TL_('What would you like to do? Choose all that apply:')),
        options: [
          {
            key: 'q7o1',
            text: i18n.getString(_TL_('I want to set a budget for specific ad channels, such as Microsoft Advertising, Google Ads, or Meta Ads.')),
          },
          {
            key: 'q7o2',
            text: i18n.getString(_TL_('I want to turn off automated text ads.')),
          },
          {
            key: 'q7o3',
            text: i18n.getString(_TL_('I want my ads to show only for certain demographics (for example, age or income).')),
          },
          {
            key: 'q7o4',
            text: i18n.getString(_TL_('I want my ads to show for people with certain interests or behaviors.')),
          },
          {
            key: 'q7o5',
            text: i18n.getString(_TL_('I want my ads to show for search phrases I identify.')),
          },
          {
            key: 'q7o6',
            text: i18n.getString(_TL_('I want more detailed reports.')),
          },
          {
            key: 'q7o7',
            hasInput: true,
            text: i18n.getString(_TL_('Other')),
            placeholder: i18n.getString(_TL_('Other')),
          },
        ],
        isVisible: answers => answers.q1.selectedOption === 'q1o7',
      },
      {
        isRequired: false,
        Type: MultipleSelectionConfigurator,
        key: 'q8',
        page: 1,
        position: 2,
        getTitle: () => i18n.getString(_TL_('Which aspect is difficult to use?')),
        options: [
          {
            key: 'q8o1',
            text: i18n.getString(_TL_('Automated text ads')),
          },
          {
            key: 'q8o2',
            text: i18n.getString(_TL_('Setting up the budget')),
          },
          {
            key: 'q8o3',
            text: i18n.getString(_TL_('Payments for advertising')),
          },
          {
            key: 'q8o4',
            text: i18n.getString(_TL_('Understanding the impact of search vs. social advertising')),
          },
          {
            key: 'q8o5',
            text: i18n.getString(_TL_('Understanding the impact of paid advertising vs. organic social engagement')),
          },
          {
            key: 'q8o6',
            text: i18n.getString(_TL_('Connecting to my social networks')),
          },
          {
            key: 'q8o7',
            text: i18n.getString(_TL_('I don\'t know where my money is being spent')),
          },
          {
            key: 'q8o8',
            hasInput: true,
            text: i18n.getString(_TL_('Other')),
            placeholder: i18n.getString(_TL_('Other')),
          },
        ],
        isVisible: answers => answers.q1.selectedOption === 'q1o8',
      },
      {
        isRequired: false,
        Type: CommentConfigurator,
        key: 'q9',
        page: 1,
        position: 3,
        getTitle: () => i18n.getString(_TL_('Do you have any other feedback you\'d like to give us about Microsoft Advertising?')),
        placeholder: i18n.getString(_TL_('Please don\'t include any confidential or personal information.')),
        isVisible: () => true,
      },
    ],
  };
};
